import type { ProductGenerationData } from '@flows-ui/services/QuoteDataContext.types'
import type { CoveragePlan } from '@flows/index'

export const getSelectedCoveragePlan = ({
  configurationParameters,
  productGeneration,
}: {
  configurationParameters: Record<string, unknown> | undefined
  productGeneration: ProductGenerationData | undefined
}): CoveragePlan | undefined =>
  (productGeneration?.coveragePlans ?? []).find((plan) =>
    (plan.configurationParameterMap ?? []).every(
      (parameter) => configurationParameters?.[parameter.parameterName] === parameter.parameterValue
    )
  )
